import MESSAGES from '../common/data/constants/messages';
import { IWorkOrderReport } from '../common/data/dtos/work-order-report';
import { IWorkOrderReportCreated } from '../common/data/dtos/work-order-report-created';
import { GET_TYPED_ASYNC, POST_TYPED_RESULT_ASYNC } from '../helpers/httpHelper';

const BASE_PATH = 'api/v1/work-order-reports';

const HTTP_UNAUTHORIZED = 401;

interface WorkOrderReportResponse {
    success: boolean;
    workOrderReport?: IWorkOrderReport;
    error?: string;
}

interface WorkOrderReportCreatedResponse {
    success: boolean;
    workOrderReportCreated?: IWorkOrderReportCreated;
    workOrderReportsCreated?: IWorkOrderReportCreated[];
    error?: string;
}

//I

/**
 * Solicita a geração assíncrona do relatório (HTTP 202). O PDF não volta na resposta:
 * o link é enviado por e-mail ao solicitante.
 */
const requestWorkOrderReport = async (workOrderIds: string[]): Promise<WorkOrderReportResponse> => {
    try {
        const response = await POST_TYPED_RESULT_ASYNC<IWorkOrderReport>(BASE_PATH, { workOrderIds });

        if (!response.success) {
            if (response.status === HTTP_UNAUTHORIZED) {
                return { success: false, error: MESSAGES.WORK_ORDER_REPORT.UNAUTHORIZED };
            }

            return {
                success: false,
                error: response.message || response.exception || MESSAGES.WORK_ORDER_REPORT.REQUEST_ERROR,
            };
        }

        return { success: true, workOrderReport: response.entity };
    } catch (err: any) {
        return { success: false, error: err.message || MESSAGES.WORK_ORDER_REPORT.REQUEST_ERROR };
    }
};

const getReport = async (id: string): Promise<WorkOrderReportCreatedResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IWorkOrderReportCreated>(`${BASE_PATH}/GetCreated?id=${id}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, workOrderReportCreated: response.entity };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getReports = async (): Promise<WorkOrderReportCreatedResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IWorkOrderReportCreated>(`${BASE_PATH}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, workOrderReportsCreated: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    requestWorkOrderReport,
    getReports,
    getReport
};
